import { isEmpty } from 'lodash';
import ActionNotification from '../components/Assets/ActionNotification';
import Button from '../components/Assets/Button';
import SectionTitle from '../components/Assets/sectionTitle';
import useAuth from '../features/auth/useAuth';

import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../App/redux/store';
import IndividualCircularLoader from '../components/Loader/IndividualCircularLoader';
import AdCardContainer from '../features/ad/components/adCardContainer/AdCardContainer';
import useAds from '../features/ad/hooks/useAds';
import AdStudyActionSelect from '../features/adStudy/components/AdStudyActionSelect';
import useFolders from '../features/folders/useFolders';
import { modalsActions } from '../features/modals/modalsSlice';
import { ReactComponent as PictoPerson } from '../images/picto-person.svg';
import { APIStatus } from '../services/axiosEnums';
import './styles/myFoldersContentPage.scss';

const collaboratorsDisplay = (collaborators: any[]) => {
  if (isEmpty(collaborators) || !collaborators) {
    return 'Aucuns';
  }
  return collaborators
    .map((elt: any) => `${elt.firstName} ${elt.lastName}`)
    .join(', ');
};

function FolderContentPage() {
  const { folderId } = useParams<{ folderId: string }>();
  const {
    ads,
    selectedAds,
    addItemToSelectedAd,
    loadActiveAd,
    adPagination,
    handlePaginationChange,
  } = useAds({});
  const { selectedFolder } = useFolders({ folderId });
  const { userIdIri } = useAuth({});

  const canEdit = selectedAds?.length === 1;
  const dispatch = useAppDispatch();

  return (
    <>
      {!selectedFolder ? (
        <IndividualCircularLoader size={200} />
      ) : (
        <main className="my-folders-details">
          <ActionNotification />
          <header className="my-folders-details-header">
            <SectionTitle
              mainTitle={`Dossier ${selectedFolder.name}`}
              subTitle="Dossiers de prospection"
              subTitleNav={`Gestion du dossier ${selectedFolder.name}`}
              link="/mes-dossiers"
            />
            <div className="my-folders-details-right-header">
              <PictoPerson />
              <p>
                {selectedFolder.collaborators &&
                  collaboratorsDisplay(selectedFolder.collaborators)}
              </p>
              {selectedFolder.owner.idIri === userIdIri && (
                <Button
                  btnType="button"
                  btnContent="MODIFIER LE DOSSIER"
                  handleClick={() =>
                    dispatch(modalsActions.updateFolder(selectedFolder))
                  }
                  primary
                />
              )}
            </div>
          </header>

          {ads.apiStatus === APIStatus.PENDING ? (
            <IndividualCircularLoader
              size={200}
              className="my-folders-details-loader"
            />
          ) : (
            <AdCardContainer
              ads={ads}
              type="adStudies"
              onPaginationChange={handlePaginationChange}
              onCheckAd={addItemToSelectedAd}
              onCardClick={loadActiveAd}
              checkedIds={selectedAds.map((m) => m.idIri)}
              adsPagination={adPagination}
              extendedDisplayParams={
                <AdStudyActionSelect
                  count={selectedAds.length}
                  folder={selectedFolder}
                  adStudy={canEdit ? selectedAds[0].adStudy : null}
                />
              }
            />
          )}
        </main>
      )}
    </>
  );
}

export default FolderContentPage;
